export default {
  pwkit: {
    title: '简介',
    titleP1:`
    PWkit是为PWmat软件开发的前后处理工具，目前主要包括三个模块：Generator、Module和Utility（开发中。。。）。
    `,
    titleP2:`
    Generator：根据可选参数（任务类型、泛函设置、赝势设置、特殊设置），为PWmat生产输入文件etot.input。
    `,
    titleP3:`
    Module：在PWmat的基础功能上，我们针对用户的需求开发了一些顶层模块（Module）。此部分提供了对Module的功能介绍
    `,
    titleP4:`
    Utility： 为了方便用户进行计算的前、后处理, PWmat安装包内附带了一系列实用程序。通过这些程序,
    我们可以实现PWmat结构文件和其他常见晶体结构文件之间的相互转换、处理数据得到可视化电荷密度、能带结构图、投影态密度、真空能级等操作。
    `,
    titleT2: '相关下载',
    titleT2P1: '下载地址',
    titleT2P2: '手册',
  }
}